
import React from 'react';
import videojs from 'video.js';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Checkbox,
  Icon,
  Input,
  Modal,
  Table,
  Tabs,
  Upload
} from 'antd';
import { CLIENT_ID } from '../../utils/constants';
import { Player } from 'video-react';
import '../../style/video-js.css';

require('videojs-contrib-hls');
const videoDefault = require('../../assets/video-default.svg');
const videoSelected = require('../../assets/video-selected.svg');
const TabPane = Tabs.TabPane;
const { TextArea } = Input;

class MeetingVideo extends React.Component {
  constructor() {
    super();
    this.state = {
      id: '0',
      meetingId: '0',
      applyType: '1',
      contactUser: '',
      contactMobile: '',
      requirement: '',
      remark: '',
      filePath: '',
      fileName: '',
      fileList: [],
      state: -1,
      livePubState: 0,
      recordPubState: 0,
      mainTainList: [],
      livePubUrl: '',
      currentVideoIndex: 0,
      videoList: []
    };
  }

  componentWillMount() {
    let newState = {};
    const { meetingVideoData, mainTainList, meetingId } = this.props;
    newState.meetingId = meetingId;
    newState.mainTainList = mainTainList || [];
    if (meetingVideoData && meetingVideoData.id > 0) {
      newState.id = meetingVideoData.id;
      newState.meetingId = meetingVideoData.meetingId;
      newState.applyType = meetingVideoData.applyType;
      newState.contactUser = meetingVideoData.contactUser;
      newState.contactMobile = meetingVideoData.contactMobile;
      newState.requirement = meetingVideoData.requirement;
      newState.remark = meetingVideoData.remark;
      newState.filePath = meetingVideoData.filePath;
      newState.fileName = meetingVideoData.fileName;
      newState.state = meetingVideoData.state;
      newState.livePubState = meetingVideoData.livePubState;
      newState.recordPubState = meetingVideoData.recordPubState;
      newState.livePubUrl = meetingVideoData.livePubUrl;
      let recordVideos = meetingVideoData.recordVideos
        ? JSON.parse(meetingVideoData.recordVideos)
        : [];
      newState.videoList = recordVideos;
    }
    if (newState.filePath) {
      let fileList = [];
      fileList.push({
        uid: `meeting_video_${Math.random()}`,
        url: newState.filePath,
        name: newState.fileName,
        status: 'done'
      });
      newState.fileList = fileList;
    }
    this.setState(newState);
  }

  render() {
    const fileUploadProps = {
      name: 'fileUpload',
      action: `/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
        'token'
      )}&fromType=${CLIENT_ID}`,
      onChange: this.fileChangeHandle,
      headers: { token: sessionStorage.getItem('token') },
      multiple: false,
      fileList: this.state.fileList,
      beforeUpload: file => {
        if (file.size == 0) {
          Modal.warning({ content: '文件大小不能为0kb！', okText: '确认' });
          return false;
        } else if (file.size > 10485760) {
          Modal.warning({ content: '文件大小不能超过10M！', okText: '确认' });
          return false;
        }
      }
    };
    let viewOnly = false,
      currentDate = new Date();
    if (
      this.props.meetingVideoData.id > 0 ||
      this.props.meeting.startTime < currentDate.getTime()
    ) {
      viewOnly = true;
    }
    let videoListDiv = [];
    if (this.state.videoList && this.state.videoList.length > 0) {
      this.state.videoList.map((item, index) => {
        let clsName = 'item';
        if (this.state.currentVideoIndex == index) {
          clsName = 'item selected';
        }
        videoListDiv.push(
          <div
            key={item.id}
            className={clsName}
            onClick={() => {
              this.setState({ currentVideoIndex: index });
            }}
          >
            <div className="imgArea">
              <img
                className="imgPic"
                src={
                  this.state.currentVideoIndex == index
                    ? videoSelected
                    : videoDefault
                }
              />
            </div>
            <div className="text">{item.name}</div>
          </div>
        );
      });
    }
    let mainTainColumn = [];
    if (this.state.mainTainList && this.state.mainTainList.length > 0) {
      mainTainColumn = [
        {
          title: '维护时间',
          width: '20%',
          key: 'time',
          render: record => {
            return record.time || '';
          }
        },
        {
          title: '维护人',
          width: '20%',
          key: 'user',
          render: record => {
            return record.user || '';
          }
        },
        {
          title: '维护记录',
          width: '60%',
          className: 'mainTain-table-remark',
          key: 'remark',
          render: record => {
            return record.remark || '';
          }
        }
      ];
    }
    return (
      <div className="meeting_video">
        <div className="button_div">
          {viewOnly || !this.props.isCreator ? null : (
            <div
              className="meeting_button"
              onClick={this.saveVideoApply.bind(this)}
            >
              保存
            </div>
          )}
        </div>
        <div className="video_table">
          <Tabs onChange={() => {}} type="card">
            {this.props.isCreator ? (
              <TabPane tab="直录播申请" key="1">
                <div className="meeting-video-form">
                  <div className="append">
                    <p className="name">
                      <i className="required-flag">*</i>
                      类型:{' '}
                    </p>
                    <div className="item">
                      <Checkbox.Group
                        disabled={viewOnly}
                        options={[
                          { label: '直播', value: '1' },
                          { label: '录播', value: '2' }
                        ]}
                        defaultValue={this.state.applyType.split(',')}
                        onChange={checkedValues => {
                          this.setState({ applyType: checkedValues.join(',') });
                        }}
                      />
                    </div>
                  </div>
                  <div className="append">
                    <p className="name">
                      <i className="required-flag">*</i>
                      对接联系人姓名:{' '}
                    </p>
                    <Input
                      className="input-item"
                      disabled={viewOnly}
                      width={40}
                      maxLength={'10'}
                      value={this.state.contactUser}
                      onChange={e => {
                        this.setState({ contactUser: e.target.value });
                      }}
                    />
                    <p className="name" style={{ marginLeft: '20px' }}>
                      <i className="required-flag">*</i>
                      对接联系人手机号:{' '}
                    </p>
                    <Input
                      className="input-item"
                      disabled={viewOnly}
                      width={40}
                      maxLength={'11'}
                      value={this.state.contactMobile}
                      onChange={e => {
                        if (
                          !isNaN(e.target.value) &&
                          String(e.target.value).indexOf('.') == -1
                        ) {
                          this.setState({ contactMobile: e.target.value });
                        }
                      }}
                    />
                  </div>
                  <div className="append">
                    <p
                      className="name"
                      style={{ float: 'left', marginTop: '10px' }}
                    >
                      直录播要求:{' '}
                    </p>
                    <div className="item">
                      <TextArea
                        className="input-area"
                        disabled={viewOnly}
                        rows={4}
                        maxLength={100}
                        placeholder={'请输入要求说明'}
                        value={this.state.requirement}
                        onChange={e => {
                          this.setState({ requirement: e.target.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="append">
                    <p
                      className="name"
                      style={{ float: 'left', marginTop: '5px' }}
                    >
                      附件:{' '}
                    </p>
                    <div className="item">
                      <Upload
                        disabled={viewOnly}
                        className={viewOnly ? 'hide-remove-icon' : ''}
                        {...fileUploadProps}
                      >
                        <Button>
                          <Icon type="upload" />
                          <FormattedMessage id="re_upload" />
                        </Button>
                      </Upload>
                    </div>
                  </div>
                  {this.state.mainTainList.length > 0 ? (
                    <div className="append">
                      <p className="name" style={{ float: 'left' }}>
                        维护记录:{' '}
                      </p>
                      <div className="item">
                        <div className="mainTain-table">
                          <Table
                            rowKey={record => record.id}
                            dataSource={this.state.mainTainList}
                            columns={mainTainColumn}
                            pagination={false}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </TabPane>
            ) : null}
            {this.props.showLiveOrVideoTab &&
            this.state.livePubState == 1 &&
            this.state.applyType.indexOf('1') > -1 ? (
              <TabPane tab="直播" key="2">
                <div className="live-box">
                  {this.state.livePubUrl ? (
                    <video
                      ref={this.startVideo}
                      id="player"
                      className="video-js vjs-default-skin"
                      controls
                      preload="auto"
                    >
                      <source
                        src={this.state.livePubUrl}
                        type="application/x-mpegURL"
                      />
                    </video>
                  ) : (
                    <div className="none-live-url">暂无直播视频源</div>
                  )}
                </div>
              </TabPane>
            ) : null}
            {this.props.showLiveOrVideoTab &&
            this.state.recordPubState == 1 &&
            this.state.applyType.indexOf('2') > -1 ? (
              <TabPane tab="录播" key="3">
                <div className="container-box">
                  {this.state.videoList.length > 0 ? (
                    <Player
                      fluid={false}
                      width={'100%'}
                      height={'100%'}
                      playsInline={true}
                      autoPlay={true}
                      src={
                        this.state.videoList[this.state.currentVideoIndex].url
                      }
                    />
                  ) : null}
                </div>
                <div className="container-list">
                  <div className="list-area">
                    <div className="title">视频列表</div>
                    {videoListDiv}
                  </div>
                </div>
              </TabPane>
            ) : null}
          </Tabs>
        </div>
      </div>
    );
  }

  startVideo = video => {
    if (video) {
      this.player = videojs(video, { autoplay: true });
      this.player.ready(function() {
        this.play();
      });
    }
  };

  fileChangeHandle = info => {
    let { file, fileList } = info;
    if (file.name.indexOf('&') > -1) {
      file.name = file.name.replace(/&/g, '$');
    }
    if (fileList.length > 1) {
      fileList = fileList.slice(-1); //后加入的排在组件的后面，所以执行splice后，返回删除的。
    }
    if (file.status === 'done') {
      if (file.response && file.response.result == 0) {
        if (file.size != 0 && file.size <= 10485760) {
          let fileUrl = file.response.list[0].fileUrl;
          this.setState({ filePath: fileUrl, fileName: file.name });
        }
      }
    } else if (file.status === 'removed') {
      this.setState({ filePath: '', fileName: '' });
    } else if (info.file.status === 'error') {
      Modal.error({
        content: this.props.intl.formatMessage({ id: 'image_upload_error' })
      });
    }
    if (file.size != 0 && file.size <= 10485760) {
      this.setState({ fileList: fileList });
    }
  };

  saveVideoApply = () => {
    let nowDate = new Date();
    if (this.props.meeting.startTime < nowDate.getTime()) {
      Modal.warning({
        content: '会议已开始,无法提交直录播申请！',
        okText: '确认'
      });
      return;
    }
    if (!this.state.applyType) {
      Modal.warning({ content: '请选择直录播申请类型！', okText: '确认' });
      return;
    }
    if (!this.state.contactUser) {
      Modal.warning({ content: '请输入对接联系人姓名！', okText: '确认' });
      return;
    }
    if (!this.state.contactMobile) {
      Modal.warning({ content: '请输入对接联系人手机号！', okText: '确认' });
      return;
    } else {
      let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(this.state.contactMobile)) {
        Modal.warning({
          content: '对接联系人手机号格式不正确！',
          okText: '确认'
        });
        return;
      }
    }
    let meetingVideo = {};
    meetingVideo.id = this.state.id;
    meetingVideo.meetingId = this.state.meetingId;
    meetingVideo.applyType = this.state.applyType;
    meetingVideo.contactUser = this.state.contactUser;
    meetingVideo.contactMobile = this.state.contactMobile;
    meetingVideo.requirement = this.state.requirement;
    meetingVideo.remark = this.state.remark;
    meetingVideo.filePath = this.state.filePath || '';
    meetingVideo.fileName = this.state.fileName || '';
    meetingVideo.state = 0;
    Modal.confirm({
      content: '直录播申请提交后,不允许修改,是否继续?',
      onOk: () => {
        this.props.dispatch({
          type: 'meetingInfo/saveVideoApply',
          meetingVideo: meetingVideo
        });
      },
      onCancel: () => {}
    });
  };
}

export default MeetingVideo;



// WEBPACK FOOTER //
// ./src/components/meetingList/MeetingVideo.js